import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-reports-janus',
  standalone:false,
  templateUrl: './reports-janus.component.html',
  styleUrl: './reports-janus.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class ReportsJanusComponent implements OnInit {

  tabsList = ['financial', 'contractor', 'permits', 'dataexport', 'custom', 'datasets'];
  subTabsList: Record<string, { label: string; route: string }[]> = {
    financial: [
      { label: 'Fees', route: 'fees' },
      { label: 'Fee Recipients', route: 'fee-recipients' },
      { label: 'Payments', route: 'payments' }
    ],
    contractor: [
      { label: 'Summary', route: 'summary' },
      { label: 'Fee Summary', route: 'fee-summary' }
    ],
    permits: [
      { label: 'Summary', route: 'summary' }
    ],
    dataexport: [
      { label: 'Export Workflow', route: 'export-workflow' },
      { label: 'Export Dataset', route: 'export-dataset' }
    ],
    custom: [],
    datasets: [
      { label: 'Data Sets', route: 'data-sets' },
      { label: 'New Data Set', route: 'new-dataset' }
    ]
  };

  selectedIndex = 0;

  activeMainTab!: string;
  activeSubTab: string | null = null;

  private storageKey = 'reports:lastSubTab';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.syncStateFromRoute();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.syncStateFromRoute();
      });
  }

  private syncStateFromRoute(): void {
    const mainRoute = this.route.firstChild;
    this.activeMainTab = mainRoute?.snapshot.url[0]?.path ?? '';
    this.selectedIndex = this.tabsList.indexOf(this.activeMainTab);
    const deepest = this.getDeepestRoute(this.route);
    this.activeSubTab = deepest.snapshot.url[0]?.path ?? null;
    if (this.activeMainTab && this.activeSubTab) {
      this.persistSubTab(this.activeMainTab, this.activeSubTab);
    }
  }

  onTabChange(index: number): void {
    const main = this.tabsList[index];
    const hasSubTabs = this.subTabsList[main]?.length > 0;
    if (!hasSubTabs) {
      this.router.navigate(
        [main],
        { relativeTo: this.route }
      );
      return;
    }

    const lastSub = this.getLastSubTab(main);
    this.router.navigate(
      lastSub ? [main, lastSub] : [main],
      { relativeTo: this.route }
    );
  }

  onSubTabClick(sub: string): void {
    this.router.navigate(
      [sub],
      { relativeTo: this.route.firstChild }
    );
  }

  private getDeepestRoute(route: ActivatedRoute): ActivatedRoute {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }

  private persistSubTab(main: string, sub: string): void {
    const store = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    store[main] = sub;
    localStorage.setItem(this.storageKey, JSON.stringify(store));
  }

  private getLastSubTab(main: string): string | null {
    const store = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    return store[main] ?? null;
  }

  formatTabLabel(tab: string): string {
    const tabChar = tab.split('data');
    let formattedLabel = 'Data ';
    if (tabChar.length > 1) {
      for (let i = 0; i < tabChar.length; i++) {
        tabChar[i] = tabChar[i].charAt(0).toUpperCase() + tabChar[i].slice(1);
        formattedLabel += tabChar[i];
      }
      return formattedLabel;
    } else {
      return tab.charAt(0).toUpperCase() + tab.slice(1);
    }
  }

}
